var modal = document.querySelector('.share-js')
var btn = document.querySelector('.myBtn-js')
var span = document.getElementById("close");

if(modal){
  btn.onclick = function() {
    modal.style.display = "flex";
  }

  span.onclick = function() {
    modal.style.display = "none";
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/pages/object/modal.js